// extracted by mini-css-extract-plugin
module.exports = {"card":"TermsOfUse_card__15MDQ"};